import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { LoggedOutLayout } from 'containers';
import { PasswordResetForm } from 'components';
import { resetPassword } from 'redux/modules/auth';
var PasswordReset = (_dec = connect(function (state) {
  return {
    user: state.auth.user,
    resetCode: state.auth.resetCode
  };
}, {
  resetPassword: resetPassword
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(PasswordReset, _Component);

  var _super = _createSuper(PasswordReset);

  function PasswordReset() {
    var _this;

    _classCallCheck(this, PasswordReset);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "submitReset", function (data) {
      if (data.password != data.passwordRepeat) {
        console.log('Passwords do not match');
        return false;
      }

      data.resetCode = _this.props.resetCode;

      _this.props.resetPassword(data).then(function () {
        _this.context.router.push('/login');
      })["catch"](function (err) {
        console.log(err);
      });
    });

    return _this;
  }

  _createClass(PasswordReset, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(LoggedOutLayout, {
        showBg: true
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "Password Reset"
      }), /*#__PURE__*/React.createElement(PasswordResetForm, {
        onSubmit: this.submitReset
      }));
    }
  }]);

  return PasswordReset;
}(Component), _defineProperty(_class2, "propTypes", {}), _defineProperty(_class2, "contextTypes", {
  router: PropTypes.object
}), _temp)) || _class);
export { PasswordReset as default };